import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Observable } from 'rxjs/Rx';

@Component({
  selector: 'menu-lateral',
  templateUrl: './menu-lateral.component.html',
  styleUrls: ['./menu-lateral.component.scss'],
})
export class MenuLateralComponent implements OnInit, OnDestroy {

  @Input() menu = [];
  @Input() titulo;
  @Input() url: Observable<any>;

  private urlObservable = null;
  public menuTogggled = false;
  private activeUrl: string;

  ngOnInit() {
    if (this.url) {
      this.urlObservable = this.url.subscribe((url) => this.activeUrl = url);
    }
  }

  ngOnDestroy() {
    if (this.urlObservable) {
      this.urlObservable.unsubscribe();
    }
  }

  estaAtivo(menu) {
    if (menu.templateLink instanceof RegExp) {
      return menu.templateLink.test(this.activeUrl);
    }
    return this.activeUrl === menu.link;
  }

  pegaTipo(menu) {
    if (menu.tipo) {
      return menu.tipo;
    }
    if (menu.fragmento) {
      return 'router';
    }
    if (menu.link.substr(0, 4) === 'http') {
      return !menu.redirect ? 'href' : 'redirect';
    }
    return 'router';
  }

  podeClicar(menu) {
    return menu.clicavel;
  }

  getLiClass(menu) {
    return {
      ativo: this.estaAtivo(menu),
      info: this.pegaTipo(menu) === 'info',
      hide: menu.hide,
    };
  }

}
